'use client'

import Link from 'next/link'
import s from './TextComponent.module.scss'
import { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import LazyImage from '@/components/Common/LazyImage'
import { PortableText } from 'next-sanity'
import { portableBlockComponents } from '@/utils/portableText'

type Props = { data: any }

export default function TextComponent({ data }: Props) {

  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <>
    <div className={s.text} ref={containerRef}>
        {data?.title && <div className={s.title}>
            <h2>{data?.title}</h2>
        </div>}
        <div className={s.contentContainer}>
          <div className={s.content}>
            {data?.contentLeft && data.contentLeft.map((textRow: any, index: number) => {
              return (
                <PortableText
                  key={textRow._key}
                  value={[textRow]}
                  components={portableBlockComponents()}
                />
              );
            })}
          </div>
          <div className={s.content}>
            {data?.contentRight && data.contentRight.map((textRow: any, index: number) => {
              return (
                <PortableText
                  key={textRow._key}
                  value={[textRow]}
                  components={portableBlockComponents()}
                />
              );
            })}
          </div>
        </div>
    </div>
    </>
  )
}